export const MARQUEE_MESSAGES: string[] = [];
